import { shortWebsite, type AdSponsor } from '../advertising/AdProvider';
import { el } from './dom';

/**
 * "sponsored by" + logo + company name + website link of the company this game belongs to (ructec 2026-10-05: "ein schönes
 * Sponsored by … dieses Logo und einen klickbaren Link mit der Website-Adresse … extrem lang kürzen wir sie"). Hidden while
 * nobody sponsors. The logo comes only from the ad backend's poster bucket, the address only as http(s) (both checked by
 * the provider); name and address are set as text, never as markup. The link opens a new tab and never steers the runner.
 */
export class SponsorBadge {
  readonly element: HTMLDivElement;
  private readonly logo: HTMLImageElement;
  private readonly name: HTMLSpanElement;
  private readonly link: HTMLAnchorElement;

  constructor(parent: HTMLElement, className: string) {
    this.element = el('div', `sponsor-badge ${className}`, undefined, parent);
    this.element.hidden = true;
    this.logo = el('img', 'sponsor-badge-logo', undefined, this.element);
    this.logo.alt = '';
    this.logo.decoding = 'async';
    this.logo.addEventListener('error', () => {
      this.logo.hidden = true;
    });
    const text = el('span', 'sponsor-badge-text', undefined, this.element);
    el('span', 'sponsor-badge-label', 'sponsored by', text);
    this.name = el('span', 'sponsor-badge-name', undefined, text);
    this.link = el('a', 'sponsor-badge-link', undefined, text);
    this.link.target = '_blank';
    this.link.rel = 'noopener noreferrer sponsored';
    // a click on the link is not a tap on the track (touch/keyboard input listens on the window)
    for (const type of ['pointerdown', 'pointerup', 'click', 'touchstart'] as const) this.link.addEventListener(type, (event) => event.stopPropagation());
  }

  set(sponsor: AdSponsor | null): void {
    this.element.hidden = sponsor === null;
    if (!sponsor) return;
    this.name.textContent = sponsor.name;
    this.element.title = `sponsored by ${sponsor.name}`;
    this.logo.hidden = sponsor.logoUrl === null;
    if (sponsor.logoUrl !== null) this.logo.src = sponsor.logoUrl;
    else this.logo.removeAttribute('src');
    this.link.hidden = sponsor.website === null;
    if (sponsor.website !== null) {
      this.link.href = sponsor.website;
      this.link.textContent = shortWebsite(sponsor.website);
      this.link.title = sponsor.website;
    } else {
      this.link.removeAttribute('href');
      this.link.textContent = '';
    }
  }
}
